import { TooltipButton } from '@/components/ui/TooltipButton'
import {
  DataTableV2Action,
  DataTableV2DataRow,
  DataTableV2DataSchema,
  DataTableV2SheetContentAction,
  DataTableV2SubmissionAction,
  DataTableV2UploadFilesAction,
} from '../types'
import { SheetContentAction } from './SheetContentAction'
import { SheetTrigger } from '@/components/shadcn/sheet'
import { Button } from '@/components/shadcn/button'
import { DynamicIcon } from '@/components/icons/DynamicIcon'
import clsx from 'clsx'
import { SubmitActionNoConfirmation } from './SbmitActionNoConfirmation'
import { SubmitActionWithConfirmDialog } from './SumbitActionWithConfirmDialog'
import { UploadFilesTableActionV2 } from './UploadFilesTableActionV2'

type TableActionsV2Props = {
  actions: DataTableV2Action[]
  dataSchema?: DataTableV2DataSchema
  localData?: DataTableV2DataRow[]
}

export function TableActionsV2({ actions, dataSchema = {}, localData = [] }: TableActionsV2Props) {
  if (!actions || actions.length === 0) return null

  return actions.map((action) => {
    if (!action.isVisible) return null
    switch (action.type) {
      case 'sheet-content': {
        const sheetContentAction = action as DataTableV2SheetContentAction
        const trigger = (
          <TooltipButton tooltip={action.label}>
            <SheetTrigger asChild>
              <Button
                disabled={action.isDisabled}
                className={clsx('h-8', { 'w-8 rounded-full': action.icon })}
                variant="ghost"
                size={action.icon ? 'icon' : 'sm'}
              >
                {action.icon && <DynamicIcon iconName={action.icon} />}
                {action.label && <span className={action.icon ? 'sr-only' : ''}>{action.label}</span>}
              </Button>
            </SheetTrigger>
          </TooltipButton>
        )
        return <SheetContentAction key={action.id} action={sheetContentAction} trigger={trigger} />
      }
      case 'submit': {
        const submissionAction = action as DataTableV2SubmissionAction
        if (submissionAction.requireConfirmation) {
          return <SubmitActionWithConfirmDialog key={action.id} action={submissionAction} actionPosition="table" />
        }
        return <SubmitActionNoConfirmation key={action.id} action={submissionAction} actionPosition="table" />
      }
      case 'upload-files': {
        const uploadFilesAction = action as DataTableV2UploadFilesAction
        return (
          <UploadFilesTableActionV2
            key={action.id}
            action={uploadFilesAction}
            dataSchema={dataSchema}
            localData={localData}
          />
        )
      }
      default:
        return null
    }
  })
}
